var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseTitleGenerator1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.442 29.2426C102.258 17.3143 88.535 8.975 72.4898 6.96936L73.0176 2.95807C73.1232 2.11359 72.5954 1.37466 71.7509 1.37466C55.1779 -0.41986 39.4494 4.33035 26.9933 13.5141C26.36 14.0419 26.2544 14.8864 26.6766 15.5197L29.1045 18.6866C17.2818 27.8703 8.94251 41.5931 6.93687 57.7439L2.92558 57.2161C2.08109 57.1105 1.34217 57.6383 1.34217 58.4828C-0.346793 74.9502 4.29786 90.7842 13.4816 103.24C14.0094 103.874 14.8539 103.979 15.4873 103.557L18.6541 101.129C27.8378 112.952 41.5606 121.397 57.6058 123.402L57.078 127.414C56.9725 128.258 57.5003 128.997 58.3447 128.997C74.8121 130.686 90.6462 126.041 103.102 116.858C103.736 116.33 103.841 115.485 103.419 114.852L100.991 111.685C112.814 102.29 121.259 88.5675 123.264 72.5223L127.276 73.0501C128.12 73.1557 128.859 72.6278 128.859 71.7834C130.548 55.316 125.903 39.4819 116.72 27.0258C116.192 26.3925 115.347 26.2869 114.714 26.7091L111.442 29.2426Z",
    fill: "#6EDBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 121.401C62.6719 120.768 62.2497 119.92 61.933 119.287C59.1884 114.22 57.2883 108.625 56.3383 103.031C55.5994 98.2804 55.4938 93.4246 56.2327 88.6744C56.5494 86.5632 57.0772 84.452 57.7106 82.4464C57.8161 82.2353 57.9217 81.9186 57.9217 81.7075C58.2384 80.9685 58.3439 80.1241 58.9773 79.4907C59.5051 78.8573 60.5607 78.5406 61.1941 79.0684C61.7219 79.4907 61.8274 80.2296 61.933 80.9685C62.0386 82.1297 62.1441 83.3964 62.2497 84.6631C62.3552 85.6132 62.4608 86.5632 62.6719 87.5133C63.0942 89.8356 64.3609 91.419 66.3665 92.2635C68.4777 93.0024 70.8001 92.6857 72.7001 91.6301C74.6002 90.5745 76.1836 88.8856 77.3448 87.091C78.8226 84.7687 79.8782 82.0241 79.7727 79.174C79.6671 76.4294 78.1893 73.5793 75.7614 72.207",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5715 2.64188L20.1323 26.2874L5.56499 46.0272C5.24831 46.4494 5.35387 46.9772 5.77611 47.2939L26.2548 60.8056L40.5054 80.7565C40.8221 81.1787 41.3499 81.2843 41.7722 80.9676L60.8786 65.6614L84.2074 58.2721C84.7352 58.1666 84.9463 57.6388 84.7352 57.111L76.0793 34.2044L76.2904 9.71442C76.2904 9.18661 75.8681 8.76437 75.3403 8.86993L50.9559 9.81998L27.7327 2.11407C27.2049 1.90295 26.7826 2.21963 26.5715 2.64188Z",
    fill: "#6EDBFF",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2786 83.1837L69.3229 84.7671C67.6339 85.6116 65.6283 84.9782 64.6782 83.3948L73.6508 78.5391C74.6009 80.228 73.9675 82.3392 72.2786 83.1837Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1596 37.4758C32.5875 36.209 35.5432 37.0535 36.8099 39.4814L39.1323 43.8094L34.8043 46.1317C32.3764 47.3984 29.4207 46.554 28.154 44.1261C26.8873 41.8037 27.7318 38.8481 30.1596 37.4758Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7563 24.3859C57.1842 23.1192 60.1399 23.9637 61.4066 26.3916C62.6733 28.8195 61.8289 31.7751 59.401 33.0419L55.073 35.3642L52.7507 31.0362C51.4839 28.6083 52.3284 25.6526 54.7563 24.3859Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3179 64.1852L54.9673 35.3672L39.1333 43.812L56.5507 69.991L61.8288 66.7186L67.3179 64.1852Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8782 65.555L52.4995 72.5L57.8169 82.339C58.8725 84.3447 61.406 85.0836 63.4116 84.028L74.9177 77.9055C76.9233 76.8499 77.6623 74.3165 76.6067 72.3108L71.4995 62.5L60.8782 65.555Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6558 80.122L75.4455 70.0938",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9116 75.0556L72.7014 65.0273",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.624 70.5177L100.78 71.0455C104.263 61.1228 100.569 53.4169 98.0352 53.7336C98.1407 52.678 98.3518 51.8335 99.3019 51.4112C101.941 50.1445 106.586 59.2227 101.624 70.5177Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1918 61.3348C96.9807 62.0737 96.8751 62.8127 96.5584 63.5516C96.3473 59.9625 92.4416 52.6789 89.9081 53.9456C89.8026 52.9956 89.697 51.7288 90.4359 51.3066C93.0749 49.8288 97.2974 57.9569 97.1918 61.3348Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6396 78.4347C93.0732 73.0511 96.1344 66.5064 97.5067 59.6449C97.8234 58.1671 97.929 56.6893 98.0345 55.2114C98.0345 53.8391 98.0345 51.939 99.3012 51.4112C101.94 50.1445 106.585 59.2227 101.624 70.5177",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0684 79.5956C97.1909 76.1121 102.363 70.7286 105.425 64.3949C105.847 63.4449 107.325 59.9614 108.908 60.2781C110.28 60.5948 110.386 62.1782 110.491 63.1282C110.703 66.9284 109.647 70.8341 107.43 74.0009C103.524 79.7012 97.8242 84.0292 94.4463 90.1517C93.1796 92.3684 92.2295 94.9019 91.5962 97.3298C90.5406 101.763 91.1739 106.513 93.074 110.736L91.0684 79.5956Z",
    fill: "#6EDBFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 63.5001C110.5 67.0001 109.646 70.8334 107.43 74.0002C103.524 79.7004 97.8237 84.0284 94.4458 90.1509C93.4958 91.8399 92.6513 93.6344 92.1235 95.5345C92.1235 95.5345 89.4388 101.055 92.5 109.5C86.2719 100.316 92.229 90.1509 92.4402 89.7287C95.8181 83.7117 101.518 79.2782 105.424 73.5779C107.641 70.4111 108.696 66.5054 108.485 62.7052C108.485 62.0719 108.422 61.1335 108 60.5001C108.317 60.289 108.908 60.2773 108.908 60.2773C110 61.0002 110.5 62.5501 110.5 63.5001Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 63.5001C110.5 67.0001 109.646 70.8334 107.43 74.0002C103.524 79.7004 97.8237 84.0284 94.4458 90.1509C93.4958 91.8399 92.6513 93.6344 92.1235 95.5345C92.1235 95.5345 89.4388 101.055 92.5 109.5C86.2719 100.316 92.229 90.1509 92.4402 89.7287C95.8181 83.7117 101.518 79.2782 105.424 73.5779C107.641 70.4111 108.696 66.5054 108.485 62.7052C108.485 62.0719 108.422 61.1335 108 60.5001C108.317 60.289 108.908 60.2773 108.908 60.2773C110 61.0002 110.5 62.5501 110.5 63.5001Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0684 79.5956C97.1909 76.1121 102.363 70.7286 105.425 64.3949C105.847 63.4449 107.325 59.9614 108.908 60.2781C110.28 60.5948 110.386 62.1782 110.491 63.1282C110.703 66.9284 109.647 70.8341 107.43 74.0009C103.524 79.7012 97.8242 84.0292 94.4463 90.1517C93.1796 92.3684 92.2295 94.9019 91.5962 97.3298C90.5406 101.763 91.1299 106.513 93.03 110.736",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8398 78.3281C88.7456 78.6448 92.6513 80.2282 95.607 82.8672",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4001 94.2695C77.9779 95.8529 77.6612 97.5419 77.5557 99.2309",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1909 61.3348C97.2965 57.9569 93.0741 49.8288 90.4351 51.3066C89.5906 51.8344 89.8017 53.3122 90.0128 54.3678C90.6462 58.3791 91.174 62.1793 90.5406 66.085C89.9073 69.9908 87.6905 74.0021 84.207 75.7966",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4015 70.9388C76.5014 71.9944 74.3902 72.5222 72.1734 72.311C71.3289 72.2055 70.3789 72.0999 69.64 71.4666C69.1122 71.0443 69.1122 70.1998 69.3233 69.5665C69.5344 68.9331 70.0622 68.4053 70.4845 67.9831C71.4345 67.1386 72.4901 66.6108 73.5457 66.1885C76.1847 65.2385 79.4571 65.5552 81.885 67.033C84.3129 68.5109 86.1074 71.0443 86.3185 73.8944L78.4015 70.9388Z",
    fill: "#6EDBFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4245 73.8945L84.5244 73.1556C83.7855 71.5722 82.5188 70.1999 80.9354 69.3554C78.5075 67.9832 75.2351 67.5609 72.5961 68.511C71.4349 68.9332 70.3793 69.5666 69.5348 70.3055C69.4293 70.411 69.3237 70.5166 69.3237 70.5166C69.3237 70.1999 69.3237 69.7777 69.4293 69.461C69.6404 68.8276 70.1682 68.2998 70.696 67.8776C71.5405 67.0331 72.5961 66.5053 73.7573 66.0831C76.3963 65.133 79.6686 65.4497 82.0965 66.9276C84.5244 68.4054 86.3189 71.0444 86.4245 73.8945Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7464 81.707C84.524 83.6071 81.3572 87.0906 79.3516 91.2075",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4015 70.9388C76.5014 71.9944 74.3902 72.5222 72.1734 72.311C71.3289 72.2055 70.3789 72.0999 69.64 71.4666C69.1122 71.0443 69.1122 70.1998 69.3233 69.5665C69.5344 68.9331 70.0622 68.4053 70.4845 67.9831C71.4345 67.1386 72.4901 66.6108 73.5457 66.1885C76.1847 65.2385 79.4571 65.5552 81.885 67.033C84.3129 68.5109 86.1074 71.0443 86.3185 73.8944",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_65736",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 101,
    width: 53,
    height: 29
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.964 111.69L103.392 114.857C103.92 115.49 103.814 116.44 103.076 116.863C90.6194 126.046 74.8909 130.796 58.318 129.002C57.4735 128.896 56.9457 128.157 57.0513 127.419L57.5791 123.407C56.3123 123.196 55.0456 122.985 53.7789 122.774L51.8447 111.023L96.902 101.785V108.006L100.964 111.69Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_65736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.542 126.568C104.053 123.824 98.8802 120.024 95.3968 114.957C94.5523 113.69 93.7078 112.212 93.0744 110.84C86.3186 117.49 76.9237 121.501 67.4233 121.924C65.9454 121.924 64.362 121.924 62.9897 121.396C63.2009 121.818 63.0953 121.607 63.2009 121.818C65.2065 125.196 67.5288 128.363 70.1678 131.213L109.542 126.568Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4342 120.765C91.4253 120.765 92.2287 119.961 92.2287 118.97C92.2287 117.979 91.4253 117.176 90.4342 117.176C89.4431 117.176 88.6396 117.979 88.6396 118.97C88.6396 119.961 89.4431 120.765 90.4342 120.765Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7097 62.918L8.73145 69.0405",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8767 69.0391L18.6543 73.4726",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9409 30.5083L95.7137 25.4414",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9409 22.8036L86.4244 19.5312",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4233 36.3133L94.2348 35.3633",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3092 14.8866C27.3092 14.8866 25.198 25.6537 23.8258 27.6594C21.1867 31.4595 20.0256 32.7263 21.2923 33.4652C22.6646 34.3097 23.4035 33.3596 26.5703 28.6094C27.6259 26.9205 31.5317 7.3918 30.3705 6.96956C29.2093 6.75844 28.576 10.4531 27.3092 14.8866Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4366 37.6863C15.0643 39.5864 10.4197 44.5477 11.3697 45.2866C12.3198 46.0255 17.4922 40.4308 18.6534 39.0586C20.9757 36.314 20.7646 35.4695 19.8146 34.9417C18.9701 34.4139 18.3367 35.1528 16.4366 37.6863Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1551 67.56C47.1551 67.56 55.9166 61.0153 56.6555 61.6486C57.2889 62.282 48.1051 69.6712 45.1495 71.888C43.2494 73.4714 40.8215 73.0492 39.7659 72.0991C37.338 69.7768 35.4379 67.1378 36.5991 65.9766C37.7602 64.8154 38.7103 65.1321 41.0326 67.9823C42.9327 70.199 45.4661 68.8267 47.1551 67.56Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6447 18.7927C71.6447 18.7927 70.2724 30.9321 71.5391 34.4156C72.8058 37.8991 75.4448 44.7605 76.3949 47.2939C77.3449 49.7218 77.7672 51.833 77.0283 52.1497C76.2893 52.4664 69.3224 38.9547 68.4779 34.9434C67.6334 30.9321 69.639 20.6927 69.9557 18.8982C70.2724 17.1037 71.0113 13.3035 71.6447 13.6202C72.278 13.9369 71.6447 18.7927 71.6447 18.7927Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseTitleGenerator1);
export default __webpack_public_path__ + "static/media/use-title-generator-1.6ffb9de7b93acdb21fc62cc6fe6417e1.svg";
export { ForwardRef as ReactComponent };